export const SINGLE_LINE_INPUT_FIELD_MAX_LENGTH = 50;
export const MULTI_LINE_INPUT_FIELD_MAX_LENGTH = 500;
export const COMMENT_MAX_LENGTH = 10000;
